export default "__VITE_ASSET__DWnG9v34__"